"use strict";

exports.__esModule = true;
exports.DeviceDataTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _DeviceDataTableProvider = require("./DeviceDataTableProvider");
var _Core = require("../../Core");
var _DataSources = require("../DataTable/DataSources");
var _helpers = require("../DataTable/helpers");
var _Device = require("../../Device");
var _PlantStateActivities = require("../../PlantStateActivities");
var _DeviceDataTable = require("./DeviceDataTable");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DeviceDataTableElement = exports.DeviceDataTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var pageSizeList = [25, 100, 500, 1000];
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var width = props.width,
    height = props.height,
    dataRange = props.dataRange,
    pageSizes = props.pageSizes,
    children = props.children,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection;
  var columns = children.map(function (_ref) {
    var props = _ref.props;
    return props;
  });
  var defaultPageSize = (pageSizes == null ? void 0 : pageSizes.at(0)) || pageSizeList[0];
  var devices = _react["default"].useContext(_Device.DeviceListContext);
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var plantStateActivities = _react["default"].useContext(_PlantStateActivities.PlantStateActivitiesContext);
  var _useState = (0, _react.useState)({
      page: 0,
      pageSize: defaultPageSize
    }),
    pagination = _useState[0],
    setPagination = _useState[1];
  var columnsConfig = children.map(function (child) {
    return child.props;
  });
  var defaultSorted = (0, _helpers.getDefaultSortOrder)(columnsConfig);
  var defaultFilters = (0, _helpers.getDefaultFilters)(columnsConfig, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  var deviceDataDefinition = _DataSources.DataSourceDefinitions["deviceData"](translate);
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    var data = [];
    var rowFormatters = deviceDataDefinition.rowFormatters;
    return /*#__PURE__*/_react["default"].createElement(_DeviceDataTable.DeviceDataTable, {
      columns: columns,
      data: data,
      height: height,
      width: width,
      defaultSorted: defaultSorted.map(function (_ref2) {
        var id = _ref2.id,
          desc = _ref2.desc;
        return {
          id: id,
          desc: desc
        };
      }),
      defaultFiltered: defaultFilters,
      defaultPageSize: defaultPageSize,
      rowFormatters: rowFormatters,
      pageSizeOptions: pageSizes || pageSizeList,
      noDataText: "Make selection to view data"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceDataTableProvider.DeviceDataTableProvider, props, function (_ref3) {
    var data = _ref3.data,
      reload = _ref3.reload,
      fetching = _ref3.fetching;
    var rowFormatters = deviceDataDefinition.rowFormatters;
    return /*#__PURE__*/_react["default"].createElement(_DeviceDataTable.DeviceDataTable, {
      "data-testid": "DeviceDataTableElement.DataTable",
      loading: fetching,
      applyPagination: function applyPagination(updatedData) {
        return updatedData.slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize);
      },
      showPagination: true,
      pages: Math.ceil(data.length / pagination.pageSize),
      page: pagination.page,
      defaultSorted: defaultSorted.map(function (_ref4) {
        var id = _ref4.id,
          desc = _ref4.desc;
        return {
          id: id,
          desc: desc
        };
      }),
      defaultFiltered: defaultFilters,
      pageSizeOptions: pageSizeList,
      pageSize: pagination.pageSize,
      onFetchData: function onFetchData(_ref5) {
        var page = _ref5.page,
          pageSize = _ref5.pageSize;
        setPagination({
          page: page,
          pageSize: pageSize
        });
      },
      columns: columns,
      data: data,
      height: height,
      width: width,
      defaultPageSize: defaultPageSize,
      rowFormatters: rowFormatters,
      reload: reload,
      style: {
        height: height + "px",
        width: width + "px"
      }
    });
  });
});